import React, { useState, useEffect } from "react";
import Modalapprove from "./../management/modalapprove";
import moment from "moment";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { datausers } from "../queue/datalist";
import {
  getMasterStatus,
  getdataapprove,
  saveapprove,
} from "./../../services/wms";
import Allapprove from "./../management/allapprove";
import { toast } from "react-toastify";

const Approve = () => {
  const [isOpen, setisOpen] = useState(false);
  const [list, setlist] = useState([]);
  const [datalist, setdatalist] = useState([]);
  const [status, setstatus] = useState([]);
  const [statusid, setstatusid] = useState(2);
  const [refresh, setrefresh] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getMasterStatus();

      if (result.status === "success") {
        setstatus(result.data.list);
      }
    };
    loadData();
  }, []);
  // console.log("status",status)
  useEffect(() => {
    const doc = {
      statusid: status,
    };
    const loadData = async () => {
      const { data: result } = await getdataapprove(
        statusid,
        "1",
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );
      if (result.status === "success") {
        setlist(result.data.list);
      }
    };
    loadData();
  }, [statusid, refresh,startDate,endDate]);
  // console.log("setlist",list)
  const handleonClick = (id) => {};

  const handleCancle = () => {
    setisOpen(false);
  };
  const handleonClickclose = (event) => {
    setlist(false);
  };
  const handleonClikisopen = (data) => {
    setdatalist(data);
    setisOpen(true);
  };
  const handleonClickapprove = (event) => {
    setstatusid(event);
  };
  const handleonClickonConfirm = (e) => {};

  const handelOnConfirm = (event) => {
    //   setrefresh(new Date())
  };
  const handleConfirmSubmit = () => {
    setrefresh(new Date());
    setisOpen(false);
    // console.log('confirm')
  };
  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };
  return (
    <>
      <Modalapprove
        onCancel={handleCancle}
        list={datalist}
        isOpen={isOpen}
        onconfirm={handleConfirmSubmit}
        // onstatus={handleonClickonConfirm}
      />
      <div className="container-fluid">
        <div className=" card1 m-2  ">
          <div className="row justify-content-center m-4">
            <div className="col-auto ">
              <span> จากวันที่</span>
              <div>
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleChangStartDate}
                />
              </div>
            </div>

            <div className="col-auto">
              <span> ถึงวันที่</span>
              <div>
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={handleChangEndDate}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {status &&
            status.length > 0 &&
            status.map((item, index) => (
              <div className=" col-lg-3 col-md-3 col-sm-6  items" key={index}>
                <div
                  className="card1 shadow text-center text-primary m-2 "
                  style={{ cursor: "pointer" }}
                  onClick={() => handleonClickapprove(item._id)}
                >
                  <div className="card-body">
                    <i className={item.icon} style={{ fontSize: "60px" }} />
                    <div className="row mb-2">
                      <span
                        className="mt-2 fw-bold"
                        style={{ fontSize: "28px" }}
                      >
                        {item.name}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <Allapprove handleonClikisopen={handleonClikisopen} list={list} />
      </div>
    </>
  );
};

export default Approve;
